{
	"active": "Attivo",
	"app_fallbacks": {
		"error": {
			"description": "Si è verificato un errore imprevisto durante il rendering di questa pagina. Puoi riprovare oppure tornare a un'area funzionante dell'app.",
			"title": "Qualcosa è andato storto."
		},
		"go_back": "Indietro",
		"go_home": "Vai alla home",
		"loading": "Caricamento",
		"not_found": {
			"description": "La pagina che stai cercando non esiste o potrebbe essere stata spostata. Torna a un'area funzionante dell'app.",
			"title": "Pagina non trovata."
		},
		"permission_error": {
			"description": "Non hai i permessi per accedere a questa pagina.",
			"title": "Accesso negato"
		},
		"try_again": "Riprova"
	},
	"app_sidebar": {
		"menu": {
			"home": "Home",
			"logout": "Esci",
			"profile": "Impostazioni"
		},
		"user_menu": {
			"open": "Apri menu utente"
		}
	},
	"back": "Indietro",
	"banned": "Bannato",
	"cancel": "Annulla",
	"change_password": "Cambia password",
	"created_at": "Data creazione",
	"delete_account": "Elimina account",
	"deleted": "Eliminato",
	"detail_section": {
		"error": "Impossibile caricare questa sezione."
	},
	"disabled": "Disabilitato",
	"edit": "Modifica",
	"email": "Email",
	"email_verified_on": "Verificata il {{date}}",
	"enabled": "Abilitato",
	"name": "Nome",
	"new_password": "Nuova password",
	"password": "Password",
	"password_min": "La password deve contenere almeno 12 caratteri.",
	"remove": "Rimuovi",
	"save": "Salva",
	"unverified": "Non verificata",
	"verified": "Verificata"
}
